import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import { Checkbox, Icon, Popup, Table } from 'semantic-ui-react';

import { wrapConsumer } from '../FilteringContextProvider';
import { filterPropsType, filterStateType } from '../../../types';
import { dbFieldType, defaultFilterColumn, entityType as et } from '../../../constants';
import { initSelectors } from '../../../behavior/init';
import { withTranslation } from 'react-i18next';
import OverviewTableCell from './OverviewTableCell';
import useUser from '@behavior/init/getUserV2';
const OverviewTableBody = ({
  actions,
  filterState,
  tableOptions,
  filterProps,
  handleFilterStateChanged,
  handleDefaultFilteredListOverride,
  renderSelection,
  selectedRows,
  onRowSelectHandler,
  isHasAnyActionRequiredRecord,
  t,
}) => {
  const { user } = useUser();
  const { filteredList, hazardList } = filterProps || {};
  const { result, entityType } = filteredList || {};

  useEffect(() => {
    const cells = document.querySelectorAll('.tableCell');
    cells.forEach(cell => {
      if (cell.offsetWidth < cell.scrollWidth) {
        cell.title = cell.textContent;
      }
    });
  });

  const isRowDisabled = rowValues => {
    return initSelectors.isRowDisabled(user, rowValues, entityType);
  };

  const isActionRequired = entry => {
    return et.inventory && entry[defaultFilterColumn.GEN_IS_CHECK_VALID] === dbFieldType.false;
  };

  const hasPreciseLocation = entry => {
    return et.inventory && entry[defaultFilterColumn.GEN_HAS_PRECISE_LOCATION] === dbFieldType.true;
  };

  return (
    <Table.Body>
      {result &&
        result.length > 0 &&
        result.map((entry, i) => {
          const rowDisabled =
            entityType !== et.batchUpdate && entityType !== et.batchUpdateSelected
              ? false
              : isRowDisabled(entry);
          const rowClass = isActionRequired(entry) ? 'actionRequired' : '';
          return (
            <Table.Row
              key={entry.ID}
              id={`row${entry.ID}`}
              onClick={event => {
                onRowSelectHandler(event, entry, false);
              }}
              active={selectedRows[entry.ID] && !rowDisabled}
              disabled={rowDisabled}
              className={rowClass}
            >
              {renderSelection && (
                <Table.Cell
                  key={'selection' + i}
                  className="contentWhiteSpace tableCellReducedPadding"
                >
                  <Checkbox
                    id={'selection_' + entityType + '_' + entry.ID}
                    name={'selection_' + entityType + '_' + entry.ID}
                    onChange={event => {
                      onRowSelectHandler(event, entry, true);
                    }}
                    checked={selectedRows[entry.ID] === true && !rowDisabled}
                  />
                </Table.Cell>
              )}
              {isHasAnyActionRequiredRecord && (
                <Table.Cell className="contentWhiteSpace tableCellReducedPadding">
                  {isActionRequired(entry) && (
                    <Popup
                      wide="very"
                      content={t('table.nonChecked.footer.warning')}
                      trigger={
                        <Icon color="orange" name="warning sign" className="tableCellWaning" link />
                      }
                    />
                  )}
                </Table.Cell>
              )}
              <OverviewTableCell
                actions={actions}
                rowCount={i}
                rowValues={entry}
                displayTableOptions={tableOptions}
                visibleColumns={filterState.visibleColumns}
                hazardList={hazardList}
                entityTypeProps={entityType}
                handleFilterStateChanged={handleFilterStateChanged}
                handleDefaultFilteredListOverride={handleDefaultFilteredListOverride}
                entityType={entityType}
              />
            </Table.Row>
          );
        })}
    </Table.Body>
  );
};

OverviewTableBody.propTypes = {
  filterState: filterStateType.isRequired,
  tableOptions: PropTypes.array.isRequired,
  filterProps: filterPropsType.isRequired,
  renderSelection: PropTypes.bool.isRequired,
  selectedRows: PropTypes.object.isRequired,
  onRowSelectHandler: PropTypes.func.isRequired,
};

export default withTranslation()(wrapConsumer(OverviewTableBody));
